import React from "react";
import {
  Box,
  Card,
  CardContent,
  LinearProgress,
  Typography,
  useTheme,
} from "@mui/material";
import { StatusBreakdown } from "../../../types/analytics";

interface StatusBreakdownChartProps {
  title: string;
  data: StatusBreakdown[];
}

const statusColorMap: Record<string, string> = {
  "#28a745": "#28a745",
  "#ffc107": "#ffc107",
  "#17a2b8": "#17a2b8",
  "#dc3545": "#dc3545",
  "#6c757d": "#6c757d",
  "#007bff": "#007bff",
  "#6610f2": "#6610f2",
};

const StatusBreakdownChart: React.FC<StatusBreakdownChartProps> = ({
  title,
  data,
}) => {
  const theme = useTheme();

  if (data.length === 0) {
    return (
      <Card sx={{ height: "100%" }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            {title}
          </Typography>
          <Typography color="text.secondary">No data available</Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          {title}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {data.map((status) => {
            const color =
              statusColorMap[status.color] ||
              status.color ||
              theme.palette.primary.main;
            return (
              <Box key={status.statusId}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 0.5,
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {status.statusName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {status.count} ({status.percentage}%)
                  </Typography>
                </Box>
                <LinearProgress
                  variant="determinate"
                  value={status.percentage}
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: `${color}20`,
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: color,
                      borderRadius: 4,
                    },
                  }}
                />
              </Box>
            );
          })}
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatusBreakdownChart;
